import React from "react";
import OpenStudiosWrap from "./OpenStudiosWrap";

function AllOpenStudios() {
  return <OpenStudiosWrap />;
}

export default AllOpenStudios;
